"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../constants");

var _Spinner = _interopRequireDefault(require("../Spinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Animation = _styledComponents.default.div.withConfig({
  displayName: "SelectMenuLoadingAnimation__Animation",
  componentId: "sc-17k54td-0"
})(["padding:", " ", ";text-align:center;background-color:", ";", ""], (0, _constants.get)('space.6'), (0, _constants.get)('space.4'), (0, _constants.get)('colors.bg.overlay'), _constants.COMMON);

const SelectMenuLoadingAnimation = props => {
  return /*#__PURE__*/_react.default.createElement(Animation, props, /*#__PURE__*/_react.default.createElement(_Spinner.default, null));
};

SelectMenuLoadingAnimation.displayName = "SelectMenuLoadingAnimation";
var _default = SelectMenuLoadingAnimation;
exports.default = _default;